import { render, staticRenderFns } from "./supplyOwnerCurrentAccount.vue?vue&type=template&id=d936dc20&scoped=true"
import script from "./supplyOwnerCurrentAccount.vue?vue&type=script&lang=js"
export * from "./supplyOwnerCurrentAccount.vue?vue&type=script&lang=js"
import style0 from "./supplyOwnerCurrentAccount.vue?vue&type=style&index=0&id=d936dc20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d936dc20",
  null
  
)

export default component.exports